import React from 'react';
import { useTranslation } from 'react-i18next';
import TutorialCard from 'components/TutorialCard';

import DropExpStep2 from 'assets/img/ranking-level-dropped-step2.png';
import DropExpStep3 from 'assets/img/ranking-level-dropped-step3.png';
import DropExpStep5 from 'assets/img/ranking-level-dropped-step5.png';
import { Link } from 'react-router-dom';
import AppRoutes from 'util/AppRoutes';

const DropRank = () => {
    const { t } = useTranslation();

    const steps = [
        {
            text: t('DROP_RANK_STEP_2'),
            img: DropExpStep2
        },
        {
            text: t('DROP_RANK_STEP_3'),
            img: DropExpStep3
        },
        {
            text: t('DROP_RANK_STEP_4'),
            img: DropExpStep5
        }
    ]

    return (
        <>
            <Link to={AppRoutes.RANKING_DROP_EXP} className="bg-gold-gradient golden-notice" style={{ margin: '1rem 1rem 0 1rem' }}>
                <div className="golden-notice-content">
                    <div>
                        <span className="text-white">{t('YOU_MAY_WANT_TO_KNOW')}</span><br />
                        <strong className="text-yellow">{t('WHAT_CAUSES_EXP_DROP')}</strong>
                    </div>
                    <div className="btn-rounded-purple">
                        <i class="las la-angle-right"></i>
                    </div>
                </div>
            </Link>
            <hr className="brand-line" />
            <div className="tutorial-list pt-0">
                {
                    steps.map((step, index) => {
                        return <TutorialCard key={index} index={index + 1} {...step} />
                    })
                }
            </div>
        </>
    );
};

export default DropRank;